import styled from 'styled-components'
import { COLORS } from '../../../../styles/colors'
import { DateInputVariant } from '../../types'

interface StyledDateInputProps {
	$variant?: DateInputVariant
	$disabled?: boolean
	$isOpen?: boolean
	$isActive?: boolean
}

export const StyledDateInput = styled.div<StyledDateInputProps>`
	position: relative;
	width: auto;
	cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
	opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`

export const InputWrapper = styled.div<StyledDateInputProps>`
	display: flex;
	align-items: center;
	padding: 8px 12px;
	border: 1px solid
		${({ $isOpen, $isActive }) =>
			$isOpen || $isActive ? COLORS.main : COLORS.inputBorder};
	border-radius: 12px;
	background: transparent;
	transition: all 0.2s ease;

	&:hover {
		border-color: ${({ $disabled }) =>
			$disabled ? COLORS.secondary : COLORS.main};
	}
`

interface InputProps {
	$isHovered?: boolean
	$isOpen?: boolean
	$isEmpty?: boolean
	$isActive?: boolean
}

export const InputText = styled.span<InputProps>`
	font-size: 14px;
	font-weight: 600;
	font-family: 'Montserrat';
	line-height: 17px;
	color: ${({ $isHovered, $isOpen, $isEmpty, $isActive }) => {
		if ($isEmpty) return COLORS.secondary
		return $isHovered || $isOpen || $isActive ? COLORS.main : COLORS.icon
	}};
	cursor: inherit;
	transition: color 0.2s ease;
	white-space: nowrap;
	user-select: none;
`

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	margin-right: 8px;
`

export const ArrowIconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	margin-left: 8px;
`
